var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativeInsight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0986 16.5355C11.3683 16.5355 11.5871 16.7543 11.5871 17.0239C11.5871 17.2935 11.3683 17.5123 11.0986 17.5123H7.45179C7.18218 17.5123 6.96338 17.2935 6.96338 17.0239C6.96338 16.7543 7.18218 16.5355 7.45179 16.5355H11.0986Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2755 9.69738C11.558 9.69738 13.4108 11.5501 13.4108 13.8326C13.4108 15.1331 12.8091 16.2942 11.8694 17.0522C11.8661 17.0555 11.8622 17.0581 11.8589 17.0607C11.7293 17.1597 11.6518 17.3115 11.6479 17.4742C11.6479 17.486 11.6473 17.4977 11.646 17.5094C11.6238 17.7425 11.618 18.0044 11.6147 18.1509C11.6108 18.3059 11.5717 18.4576 11.4995 18.595L11.1569 19.2501C10.983 19.5829 10.6385 19.7913 10.2629 19.7913H8.28842C7.91262 19.7913 7.56811 19.583 7.39435 19.2501L7.05183 18.595C6.97955 18.4577 6.94052 18.3059 6.93659 18.1509L6.921 17.4743C6.91708 17.3063 6.83695 17.1493 6.70286 17.0471C6.70155 17.0458 6.70024 17.0451 6.69828 17.0438C5.74491 16.2994 5.14062 15.1364 5.14062 13.8326C5.14062 11.5501 6.9933 9.69733 9.27589 9.69733L9.2755 9.69738ZM9.2755 10.6742C7.53217 10.6742 6.11704 12.0893 6.11704 13.8326C6.11704 14.8231 6.57416 15.7081 7.29447 16.2701C7.66437 16.5514 7.8858 16.9865 7.89744 17.4508L7.91303 18.128C7.91303 18.1326 7.91434 18.1378 7.91695 18.1423L8.25948 18.7967C8.26471 18.8079 8.27638 18.8143 8.28815 18.8143H10.2626C10.2744 18.8143 10.2854 18.8078 10.2913 18.7967L10.6338 18.1423C10.6364 18.1377 10.6377 18.1325 10.6377 18.128C10.6416 17.9679 10.6488 17.6845 10.6716 17.4331C10.6879 16.9838 10.9029 16.5645 11.2623 16.287C11.9767 15.7082 12.4338 14.8231 12.4338 13.8327C12.4338 12.0894 11.0188 10.6742 9.27536 10.6742L9.2755 10.6742Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0885 14.9082C2.8189 14.9082 2.6001 14.6894 2.6001 14.4198C2.6001 14.1502 2.8189 13.9314 3.0885 13.9314H3.73968C4.00928 13.9314 4.22808 14.1502 4.22808 14.4198C4.22808 14.6894 4.00928 14.9082 3.73968 14.9082H3.0885Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4614 13.9306C15.731 13.9306 15.9498 14.1494 15.9498 14.419C15.9498 14.6886 15.731 14.9074 15.4614 14.9074H14.8102C14.5406 14.9074 14.3218 14.6886 14.3218 14.419C14.3218 14.1494 14.5406 13.9306 14.8102 13.9306H15.4614Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6703 10.74C14.9034 10.6052 15.2023 10.6853 15.3372 10.9184C15.4719 11.1522 15.3919 11.4511 15.1587 11.586L14.5948 11.9116C14.361 12.0464 14.0621 11.9663 13.9272 11.7325C13.7925 11.4994 13.8725 11.2005 14.1064 11.0656L14.6703 10.74Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1079 8.53457C12.2421 8.30149 12.5415 8.22135 12.7747 8.35611C13.0085 8.49086 13.0886 8.78979 12.9539 9.02299L12.6282 9.58695C12.4935 9.82069 12.1945 9.90081 11.9607 9.76607C11.7276 9.63132 11.6475 9.33239 11.7822 9.09854L12.1079 8.53457Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78613 7.90683C8.78613 7.63723 9.00493 7.41843 9.27454 7.41843C9.54415 7.41843 9.76295 7.63723 9.76295 7.90683V8.558C9.76295 8.82761 9.54415 9.04641 9.27454 9.04641C9.00493 9.04641 8.78613 8.82761 8.78613 8.558V7.90683Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59572 9.02375C5.46098 8.79066 5.541 8.49175 5.77419 8.35686C6.00792 8.22211 6.30686 8.30213 6.44171 8.53533L6.76735 9.09928C6.9021 9.33302 6.82208 9.63195 6.58823 9.76681C6.35515 9.90155 6.05556 9.82153 5.92135 9.58769L5.59572 9.02375Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39087 11.5859C3.15778 11.4512 3.07765 11.1523 3.2124 10.9191C3.34715 10.6853 3.64608 10.6052 3.87929 10.7399L4.44324 11.0656C4.67698 11.2003 4.75711 11.4992 4.62236 11.7331C4.48762 11.9662 4.18869 12.0463 3.95484 11.9116L3.39087 11.5859Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32666 5.24661L8.81704 1.93185L14.3862 6.26839L17.8844 2.72032",
    stroke: "#333333",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.81697,
    cy: 1.92879,
    r: 1.18269,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.336,
    cy: 6.26842,
    r: 1.18269,
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2784,
    cy: 2.32609,
    r: 1.18269,
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.72078,
    cy: 5.08263,
    r: 1.18269,
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeInsight);
export default __webpack_public_path__ + "static/media/creative_insight.4c5f0b94b91bd460af728d772fd77b4c.svg";
export { ForwardRef as ReactComponent };